exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div[data-v-193d8fe9] {\n  background: #ccc;\n  display: flex;\n}", ""]);

// exports
